export default "__VITE_ASSET__D8B7Xxx9__"